import { pathJoin } from 'src/reducers/routing/utils'

export const createAssetManagementRoutesMap = (prefix: string) => ({
  'container-types': pathJoin(prefix)('container-types').chain,
  'waste-fractions': pathJoin(prefix)('waste-fractions').chain,
  'spare-parts': pathJoin(prefix)('spare-parts').chain,
  'part-types': pathJoin(prefix)('part-types').chain,
  // REQ-386 slice 4: admin-extensible waste-water appliance catalogue.
  'waste-water-appliances': pathJoin(prefix)('waste-water-appliances').chain,
  'key-types': pathJoin(prefix)('key-types').chain,
})
